export const WAREHOUSE_GRID_CODES = {
  warehouseCreditNote: 'warehouse-credit-note',
  warehouseCreditNoteItemAdd: 'warehouse-credit-note-item-add',
  warehouseCreditNoteItem: 'warehouse-credit-note-item',
  warehouseIssueNoteCorrections: 'warehouse-issue-note-corrections',
  warehouseIssueNoteCorrectionItems: 'warehouse-issue-note-correction-items',
  warehouseServiceOrderReturns: 'warehouse-service-order-parts-return',
  warehouseServiceOrderReturnSelectItems: 'warehouse-service-order-return-select-items',
  warehouseServiceOrderPartsReturnItem: 'warehouse-service-order-parts-return-item',
  warehouseCostCorrections: 'warehouse-issue-note-cost-corrections-list',
  warehouseCostCorrectionItems: 'warehouse-issue-note-cost-correction-items',
  warehouseDirectSaleItem: 'direct-sale-item',
  warehousePurchaseList: 'warehouse-purchase-list',
  warehouseSupplierOrders: 'warehouse-supplier-orders',
  warehouseSupplierOrderItems: 'warehouse-supplier-order-items',
  warehouseSupplierOrdersPending: 'warehouse-supplier-orders-pending',
  warehouseSupplierOrderPurchaseListCart: 'warehouse-supplier-order-purchase-list-cart',
  warehouseServiceOrderPartsReturnSelectOrder: 'warehouse-service-order-parts-return-select-order',
  issueNoteServiceOrderAddedItems: 'issue-note-service-order-added-items',
  supplierPriceList: 'supplier-price-list',
  receiveNoteBasketArticle: 'receive-note-basket-article',
  priceListBasket: 'supplier-price-list-cart',
  articleUpdateJobs: 'warehouse-article-update-job',
  articleUpdateJobItems: 'warehouse-article-update-job-item',
  articleUpdateJobLog: 'warehouse-article-update-job-log',
  articleUpdateJobBasketItems: 'warehouse-article-update-job-article-select',
  fastTrackIssues: 'fast-track-issues',
  fastTrackIssueAssignOrder: 'fast-track-issue-assign-order',
  fastTrackIssueItems: 'fast-track-issue-items',
  fastTrackIssueAddItems: 'fast-track-issue-add-items',
  fastTrackIssueItemsRelatedSourceDoc: 'fast-track-issue-items-related-source-doc',
  deliveryNoteList: 'warehouse-delivery-notes',
  deliveryNoteItems: 'warehouse-delivery-note-items',
  articleReceipts: 'warehouse-article-inventory',
  issueNoteServiceOrders: 'issue-note-service-orders',
  directSaleFullyReturnedItems: 'direct-sale-item-fully-returned',
  directSale: 'direct-sale',
  serviceOrderArticleReservation: 'service-order-job-article-reservation',
  transferOrderVariants: 'warehouse-transfer-order-variant',
  warehouseTransferOrder: 'warehouse-transfer-order',
  warehouseTransferOrderItems: 'warehouse-transfer-order-item',
  warehouseTransferOrderBasket: 'warehouse-transfer-order-add-item',
  articleUpdateJobsLog: 'warehouse-article-update-job-log-article',
  warehouseArticleCatalogsInfo: 'warehouse-article-catalogs-info',
  warehouseSpace: 'warehouse-space',
  assignStorageLocationWarehouseSpace: 'assign-storage-location-warehouse-space',
  assignWarehouseArticleToStorageLocation: 'assign-warehouse-article-to-storage-location',
};
